import { render, staticRenderFns } from "./RabbeyTopMenu.vue?vue&type=template&id=3d5f2126&scoped=true&"
import script from "./RabbeyTopMenu.vue?vue&type=script&lang=js&"
export * from "./RabbeyTopMenu.vue?vue&type=script&lang=js&"
import style0 from "./RabbeyTopMenu.vue?vue&type=style&index=0&id=3d5f2126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f2126",
  null
  
)

export default component.exports